const STORE_PREFIX = "opus";

interface StorageTypes {
	accessToken: string;
	refreshToken: string;
	timer: string;
	accessStatus: "Admin" | "Staff" | "Approver";
}

const storage = {
	setItem: <T extends keyof StorageTypes>(name: T, value: StorageTypes[T]) =>
		localStorage.setItem(`${STORE_PREFIX}-${name}`, value),
	getItem: <T extends keyof StorageTypes>(name: T) =>
		localStorage.getItem(`${STORE_PREFIX}-${name}`) as StorageTypes[T],
	removeItem: <T extends keyof StorageTypes>(name: T) =>
		localStorage.removeItem(`${STORE_PREFIX}-${name}`),
};

export default storage;
